<div class="modal-header">
  <h4 class="modal-title">Report</h4>
  <button (click)="cancel()" aria-label="Close" class="modal-close" type="button">
    <font-awesome [icon]="'fa-regular fa-xmark'"></font-awesome>
  </button>
</div>
<div class="modal-body d-flex justify-content-center">
  <div id="htmlData">
    <div class="container px-0">
      <div class="row">
        <div class="col">
          <img src="../../assets/img/samsung-logo.png">
          <div class="py-24px">Samsung Electronics America, Inc</div>
          <div class="report-box box-1-1 p-8px">
            <div class="d-flex flex-row">
              <div class="info-label">Date</div>
              <div class="info-value">: 2022.08.20</div>
            </div>
            <div class="d-flex flex-row">
              <div class="info-label">Ref #</div>
              <div class="info-value">: SS_0A58HCPT200284H_0</div>
            </div>
            <div class="d-flex flex-row">
              <div class="info-label">Acct #</div>
              <div class="info-value">: 1811436</div>
            </div>
            <div class="d-flex flex-row">
              <div class="info-label">Account Name</div>
              <div class="info-value">: INTERBOND/BRANDSMART USA</div>
            </div>
            <div class="d-flex flex-row">
              <div class="info-label">To</div>
              <div class="info-value">: INTERBOND/BRANDSMART USA</div>
            </div>
            <div class="d-flex flex-row">
              <div class="info-label">Attn</div>
              <div class="info-value">:</div>
            </div>
            <div class="d-flex flex-row">
              <div class="info-label">Address</div>
              <div class="info-value">: 3200 SW 42ND STREET</div>
            </div>
            <div class="d-flex flex-row">
              <div class="info-label"></div>
              <div class="info-value">: FORT LAUDERDALE,</div>
            </div>
            <div class="d-flex flex-row">
              <div class="info-label"></div>
              <div class="info-value">: FL, 33312</div>
            </div>
            <div class="d-flex flex-row">
              <div class="info-label">Phone</div>
              <div class="info-value">: 954-797-4000</div>
            </div>
            <div class="d-flex flex-row">
              <div class="info-label">Fax</div>
              <div class="info-value">:</div>
            </div>

          </div>
          <div class="report-box box-1-2">
            <div class="d-flex flex-row justify-content-between">
              <div class="info-label">LC27T550FDNXZA</div>
              <div class="info-value">1.000</div>
            </div>
            <div class="info-label pl-48px">0A58HCPT200284H</div>

          </div>
          <div class="report-box box-1-3">
            <div class="d-flex flex-row justify-content-between">
              <div class="info-label font-weight-bold">TOTAL UNIT QTY</div>
              <div class="info-value">1.000</div>
            </div>
          </div>
        </div>

        <div class="col">
          <h5>DEFECTIVE RETURN AUTHORIZATION</h5>
          <div class="report-box box-2-1">705229412</div>
          <div class="info-italic py-4px">This number must be prominently
            displayed on all applicable cartons
          </div>
          <div class="report-box box-2-2">
            <h3>Shipping instructions</h3>
            <div class="info-italic pb-8px">Approved Materials to be shipped via Prepaid
              Carrier to:
            </div>
            <div class="address-bold">110 E. Lambert Road
              Fullerton, CA, 92835
              Tel# :
              Fax#
            </div>
            <div class="info-italic py-10px"> CARRIER MUST CALL FOR APPOINTMENT</div>
            <div class="info-italic font-size-10">*Units must be in original boxes (one per carton)
              *Accessories must be included
              *Dealer will be charged back for all missing parts
              and accessories
              *Shipments must be palletized and securely shrink
              wrapped
              *Damaged units subject to refusal, reduced credit, or
              no credit at all
              *A copy of this form must be included as a packing
              slip
              ****************************************
            </div>
            <div class="info-italic font-size-10 py-8px">Debit memo MUST include Defective
              Return Authorization number to receive credit
            </div>
          </div>
          <div class="report-box box-2-3">
            <div class="info p-8px">Comment :
              0A58HCPT200284H
              SS Brandsmart_081922_20 INSPECTED 11 APP
            </div>
            <div class="info p-8px pt-50px">Service Return as requested via :</div>
          </div>
          <div class="report-box box-2-4">
            Order Reason :
            [RT] Exceptional Sales Return
            Authorization Valid for 30 days
          </div>
        </div>
      </div>
      <div class="info p-8px"> Legal Disclaimer</div>
      <div class="report-box info-italic font-size-10 p-8px">Samsung shall not be liable for any non-Samsung product or
        non-authorized Samsung product
        returned under this Defective Return Authorization (DRA). If Samsung receives any
        non-authorized or non-Samsung product, we will inform you that you have 10 days to pick up
        the product. If you do not pick up the product within 10 days, Samsung shall destroy the
        product and charge back any such costs to you. By returning product under this DRA, you
        expressly agree to the above provision.
      </div>
      <div class="report-box info p-8px">
        <div class="pb-4px">Transmitted By :SangYongAn</div>
        <div class="pb-4px">Date : 2022.09.07 23:00:44</div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button (click)="download()" class="btn btn-dark" type="button">
    <span class="btn-font-cancel">Download</span>
  </button>
</div>
